<script setup>
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import HeatmapContainer from './components/HeatmapContainer.vue';
import AgentLiveReportContainer from './components/AgentLiveReportContainer.vue';
import TeamLiveReportContainer from './components/TeamLiveReportContainer.vue';
import StatsLiveReportsContainer from './components/StatsLiveReportsContainer.vue';
</script>

<template>
  <!-- Padrao StudioAgents-style: PageLayout + PageHeader full-width. -->
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-activity"
        accent="teal"
        :title="$t('OVERVIEW_REPORTS.HEADER')"
        :subtitle="$t('OVERVIEW_REPORTS.SUBTITLE')"
      />
    </template>
    <div class="flex flex-col gap-4">
      <StatsLiveReportsContainer />
      <HeatmapContainer />
      <AgentLiveReportContainer />
      <TeamLiveReportContainer />
    </div>
  </PageLayout>
</template>
